import Node from 'ln/node/Node';
import BaseView from './BaseView';
import UserSequenceModel from '../models/UserSequenceModel';
import SlrgUserSequenceModel from '../models/SlrgUserSequenceModel';
import CustomUserSequenceModel from '../models/CustomUserSequenceModel';
import PauseModel from '../models/PauseModel';
import DaybreakModel from '../models/DaybreakModel';
import CourseElementModel from '../models/CourseElementModel';
import Course from "./Course";
import CoursePreview from "./CoursePreview";
import SequenceImporter from "./SequenceImporter";
import Panel from "../../general/Panel";
import { scanner } from 'ln/view/Scanner';
import setup from 'ln/setup/setup';
import { backend } from '../../setup';
import CustomSlrgUserSequenceModel from '../models/CustomSlrgUserSequenceModel';

type MoveDirection = 'up' | 'down';

class CourseElement extends BaseView {
	
	public model:CourseElementModel;

	private sequenceFactory = {
		"slrg": CustomSlrgUserSequenceModel,
		"ssb": CustomUserSequenceModel,
		"smsv": CustomUserSequenceModel,
		"App\\SlrgSequence": SlrgUserSequenceModel,
		"App\\Sequence": UserSequenceModel
	};
	
	constructor( model:CourseElementModel, courseView:Course|CoursePreview ){
		super( model );
	}
	
	public init(){
		
		var pauseNode = this.node.js( 'add-pause' );
		if( pauseNode ) pauseNode.click.add( this.addPause, this );
		
		var breakNode = this.node.js( 'add-daybreak' );
		if( breakNode ) breakNode.click.add( this.addDaybreak, this );
		
		var addNode = this.node.js( 'add-sequence' );
		if( addNode ) addNode.click.add( this.addSequence, this );

		var importNode = this.node.js( 'import-sequence' );
		if( importNode ) importNode.click.add( this.importSequence, this );

		let elementDeleteNode = this.node.js('delete');
		if(elementDeleteNode) {
			elementDeleteNode.click.add(this.deleteElement, this);
		}

		const moveUp = this.node.js( 'move-up' );
		if( moveUp ) moveUp.click.add( this.moveElementUp, this );
		const moveDown = this.node.js( 'move-down' );
		if( moveDown ) moveDown.click.add( this.moveElementDown, this );

		this.model.course.rerenderDisplayTime.add( this.renderDisplayTime, this );

		scanner.scan( this.node );
		
	}

	
	protected addPause() {
		var model = new PauseModel({  
			time:15,
			modelName:"App\\Pause",
		});
		
		this.addNewModel( model );
	}

	protected addSequence() {

		var model = this.sequenceFactory[ setup.data( 'env' ) ].getInstance();
		
		this.addNewModel( model );
	}


	protected importSequence() {
		var panel = new Panel();
		var importer = new SequenceImporter();

		// callback when a sequence is selected
		importer.selected.add( ( selected:any ) => {
			panel.hide();

			var model = null;

			if( selected.modelName == 'App\\CustomUserSequence' || selected.modelName == 'App\\CustomSequence' || selected.modelName == 'App\\CustomSlrgUserSequence' ){

				setup.route( 'api.duplicate.customusersequence', { id: selected.id } ).load().then( ( result:any ) => {
					model = backend.mapper.model( result );
					model.done = false;
					this.addNewModel( model );
				});

			} else {
				
				model = this.sequenceFactory[ selected.modelName ].getInstance( selected );
				this.addNewModel( model );
			}


		});

		panel.show( importer.node, Node.one( 'body > .container' ) );
	}


	protected addDaybreak(){
		var model = new DaybreakModel( {  
			date: new Date().toISOString().substring( 0, 10 ),
			time: "10:00",
			modelName: "App\\Daybreak"
		});

		this.addNewModel( model );
	}


	protected deleteElement() {
		this.model.delete().then( function() {
			
			this.model.course.sequences.remove( this.model );

			this.model.course.rerenderDisplayTime.remove( this.renderDisplayTime, this );
			this.model.course.rerenderDisplayTime.dispatch();
		}.bind( this ) );
	}


	protected addNewModel( model:CourseElementModel ) {

		model.course = this.model.course;
		model.backend = this.model.backend;
		
		model.save().then( function( backendModel:CourseElementModel ) {
			this.model.course.sequences.add( model, this.model.course.sequences.index( this.model ) + 1 );
			this.model.course.rerenderDisplayTime.dispatch();
		}.bind( this ) );

	}

	protected moveElementUp( ){
		this.moveElement( 'up' );
	}

	protected moveElementDown(){
		this.moveElement( 'down' );
	}

	private moveElement( direction:MoveDirection ){
		const elements = this.model.course.sequences.all();
		const index = elements.indexOf( this.model );
		if( direction == 'up' && index > 0 ){
			const element = elements[index];
			elements[index] = elements[index-1];
			elements[index-1] = element;
		} else if( direction == 'down' && index < this.model.course.sequences.length -1 ){
			const element = elements[index];
			elements[index] = elements[index+1];
			elements[index+1] = element;
		}
		this.model.course.sequences.sort(elements);
		this.model.course.save();
		this.model.course.rerenderDisplayTime.dispatch();
		
	}

	protected renderDisplayTime(){};

	// make shure all a-tags have attribute _blank
	protected blankLinks(){
		this.node.all( 'a' ).forEach( link => {
			link.setAttribute( 'target', '_blank' );
		});
	}

}

export default CourseElement;